import { ToothDataEntry, ToothSurfaceDataType } from '../teethData';
import { ToothView } from '../../../Enums/ToothView.enum';
import {
	ToothFracturePosition,
	ToothFractureType,
	ToothSurface,
} from '../../../../../graphql/graphql';

export const Tooth27: ToothDataEntry = {
	[ToothView.PALATAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M8.4,60.7l.8-17.2,9.1-8.5,10.6-6.4,11.9-5.1,11.9-3.4,10.4-1.1,12.3,1.1,10.6,1.3,11.2,1.3,9.1,2.1,8.5,3.8,6.6,3.8,14-4.9,11.9-2.3h22l12.3,4.2,12.3,10,8.1,12.5,3.4,9.8.4,10.6-.2,15.7-1.5,14.6-2.1,10.6-3.8,13.4s-45.1,40.1-166.4,7.8l-8.3-20-9.3-31.8-5.7-21.9Z',
			},
			[ToothSurface.Palatal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M125,73.7a15.2,15.2 0 1,1 -30.4,0a15.2,15.2 0 1,1 30.4,0Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M62.8,20.5v65.3s1.7,19-13.5,19h-27.7l-12.5-41.1v-17l4.3-7,5.7-4.4,7.4-4.7,8.2-3.7,8.4-3.1,8.5-2.3,11.2-1Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M149.4,27.2l16.7-.3,9.2,1.8,7.4,3.4,7.1,5.5,6.2,6.5,4.8,8.7,3,8.8,1.3,5.2v19.3l-1.1,8.9-1.7,10.1h-38.3s-14.8,2.7-14.8-12.3l.2-65.7Z',
			},
			[ToothSurface.CervicalPalatal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M31.8,134.4s109.8,32.5,166.4-7.8l-6.5,13.6s-48.4,41-156.9,2.7l-3.1-8.4Z',
			},
			[ToothSurface.MesioPalatalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M121.4,32.5l-15.1-7.6-20.3-3.4-22.9-2.3-10.4,1.1-11.9,3.4-11.9,5.1-10.6,6.4-9.1,8.5-1.1,8.2v8.2l1.9,10.6,7,20.5,6.4,23.4,8.3,20c38.7,11.3,76.8,12.5,76.8,12.5,0,0-27.9-84.8,12.9-114.5Z',
			},
			[ToothSurface.DistoPalatalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M198.2,126.6l3.8-13.4,2.1-10.6,1.5-14.6.2-15.7-.4-10.6-3.4-9.8-8.1-12.5-12.3-10-12.3-4.2h-22l-11.9,2.3-14,4.9s-40.3,19.1-12.9,114.5c0,0,59.5,3.5,89.6-20.3Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Horizontal}`]: [
				'13.3 76 39.2 55.3 43.8 88.5 62.2 53.1 78.1 89.6 94.7 52.7 112.2 87.1 128.8 51.3 145.4 87.6 161.2 50.6 175.6 86.6 185.5 53.7 204.9 77.3',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Vertical}`]: [
				'114.2 104 100.6 112.2 116.6 121.3 102.8 129.6 117.7 138 104.6 146 117.9 153.5 105.2 161.2 120.6 169.9 108 177.3 120.3 184.1 107.8 191.6 121.3 199.1 108 207.2 120.7 214.1 107.4 222 119.2 228.8 106.3 236.5 120.6 244.6 105.5 253.6 119.2 261.5 104.3 270.4 118.6 278.4 103.9 287.1 120 296.3 106.6 304.4 121.6 313 105.6 322.5 119.9 330.7 105.3 339.3 120.5 347.8 104.9 359.6 120 365.4 104.6 377.7 121.2 382.6 108.8 403.8',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Horizontal}`]: [
				'166.1 263.6 158.6 248.8 148.4 263.8 137.7 250 127.6 263.8 114.9 248.5 102.1 263.8 90.7 248.8 76.7 266.3 65.1 250.3 53.7 265.9',
			],
		},
	},
	[ToothView.INCISAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M26.9,48.5l3.9-8.9,2.4-2.9,2.2-2.6,2-2.2,4.5-3.9,5-2.7,4.3-2.6,4.5-2.2,5-1.8,5-1.1,4.7-.9s1.1-.2,2.4-.2,7.1.4,7.1.4l3.2.2,5.4,1.6,2.9,1.3,5.4,1.5,4.1,1.5,6.1,1.8,4.1,1.1,2.9.7,11.7.2h5l4.3.5,6.3,1.6,5.6,2.4,5,2.7,7.8,4.3,5.8,5,5.4,4.9,3.8,3.9,1.5,2.4,1.6,4.1,1.8,3.2,1.1,8.7s.7,3.9.7,4.5.7,6.7.7,6.7l10.1,33.3.2,6,.2,7.1-.5,8.2-.5,6.5-1.3,4.5-2,6-2.4,4.5-3.8,6.9-3.6,4.7-6.1,4.1-7.1,5-6.5,2.4-3.2,2.2-6.9,2.9-4.5.9-7.4,1.5-7.8,1.8-12.6.7-6.3.9-3.9.2-4.9-.2-8.7.4h-3.9l-4.7-1.1-9.3-2.6-6.3-2.4-4.5-3.2-3.8-3.6-3.8-3.8-2.7-2.9-3.4-4.9-5.6-10.8-5.6-12.8-5.6-11.4-4.7-13.4-2.2-10.8-3.4-26.9.2-16.8,1.1-8.5,2-7.8h0Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M42.6,153.3l-2.7-8.2-5.5-9.7-4.5-14.6-5-17.9-2-15.9-.2-15.6,1-11.7,3-11.4,32.9,30.1s26.6,17.2,10.4,41.4l-27.4,33.5Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M176,55.7l3.8,6.8,1.2,11.6,1.2,6.8,7,18,3.2,11.8.6,8,.2,16.8-3.6,17.4-35.8-28.3-2.8-2.5s-18.6-15.7-2.8-31.9l8-9.6,19.8-24.9Z',
			},
			[ToothSurface.MesioBuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M105.9,23.9l-23.8-7.8-14-.2-15.4,5.6-10.6,6.6-8.2,6.8-5.2,7.4-1.9,6.1,32.9,30.1s30.5,12.9,37.7,2.2,9.9-21.8,8.5-56.8Z',
			},
			[ToothSurface.DistoBuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M105.9,23.9l7.8,2.6,13.4-.6,10.6,1.6,11.2,3.8,9.6,5.2,8,5.8,6,5.6,3.6,7.8-19.8,24.9s-21.2,7.8-27,1.6c-19-20.5-31.8-1.4-31.8-1.4,0,0,10.3-24.2,8.5-56.8Z',
			},
			[ToothSurface.DistoPalatalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M189.6,152.8l-5.3,9.3-9.6,10.9-12.9,8.2-16.5,6.6-13.7,2.6-11.1,1s-2.3-30,13-47.4,8.8-12.3,9.9-16.1c1.6-5.7-.4-8.2-.4-8.2l10.6,4.8,35.8,28.3Z',
			},
			[ToothSurface.MesioPalatalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M120.7,191.4h-33l-15.8-3.4-12-8.9-8.2-9.2-9.1-16.6,27.4-33.5s8.1-5.3,17.5-5.3,14,10,24.8,10,10.6-8.3,20.3-8.3,10.7,3.5,10.4,3.5c7.4,9.2-9.5,24.3-9.5,24.3,0,0-13.7,14.1-13,47.4Z',
			},
			[ToothSurface.Occlusal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M59.7,78.4s30.3,12.5,37.7,2.2c10.7-14.8,25-6.6,31.8,1.4s24.3-1.6,27-1.6-27.7,21-5.2,41.5l2.8,2.5s-17.4-8.3-21.1-8.3-8.2,8.3-20.3,8.3-16.9-10-24.8-10-17.5,5.3-17.5,5.3c-9.8,7.4,22.6-16.7-10.4-41.4Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Vertical}`]: [
				'190.4 111.7 174.5 85.8 166 120.6 155.1 78 140.5 121.8 127.1 78 112.1 121.2 98.2 78 83.3 124 70.9 80.2 54.9 124 49.9 87.4 29.5 111.2',
			],
		},
	},
	[ToothView.BUCCAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M196.8,377.2l4,13.1,1.3,11.1,1.8,13.8.9,8.4-.7,8-1.6,7.1-2.7,7.5-4.9,6.2-1.6,6.9-3.1,8.9-4.9,8-6,5.1-8,4-12.2,2.9-6.7.4-12.7.2-22.6-3.8h-12.7l-19.1,6-27.1.2-16-3.6-16.2-5.3-9.8-8.7-3.6-9.5-1.1-10,.9-9.8,3.8-16.4,14.9-35.3s67.4-34.2,165.4-15.5Z',
			},
			[ToothSurface.CervicalBuccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M31.4,392.8s66.9-34.2,165.4-15.5l-2.6-8.2s-88.4-25.3-158.3,13.3l-4.6,10.4Z',
			},
			[ToothSurface.Buccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M127.5,424.8a13.9,13.9 0 1,1 -27.8,0a13.9,13.9 0 1,1 27.8,0Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M24.4,412.3h40s9.8,1.6,9.8,12v66.8l-14.2.2-20.6-4.4-14.4-6.2-7.8-7.3-4-9.8-.7-16.7,4-16.7,8-18Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M203.1,411.8h-47.5s-10.2,2.7-10.2,11.3.7,65.7.7,65.7l24.2-3.6,9.5-4.2,8-8,4.9-10,2.9-11.1,6-8.4,3.3-12v-13.8l-1.8-6Z',
			},
			[ToothSurface.DistoBuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M114.6,484.7l13.1,1.8,15.1,2.2h13.5l14.7-3.3,12-6,6.7-8.7,4-9.1,1.6-8.2,6.7-10.4,2.9-13.3v-14.7l-2.4-19.5-5.4-18.2s-35.3-6.9-63-5.5c0,0,8.2,27.9-2.9,44.6-11.2,16.8-16.4,68.4-16.4,68.4Z',
			},
			[ToothSurface.MesioBuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M31.4,392.8l-14.9,35.3-3.8,16.4-.9,9.8,1.1,10,3.6,9.5,9.8,8.7,16.2,5.3,16,3.6,27.1-.2,19.1-6,9.9-.4s5-50.5,16.4-68.4c10.9-17.1,2.9-44.6,2.9-44.6,0,0-55.4-.9-102.5,21.1Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Horizontal}`]: [
				'199.7 440.9 182.5 414.1 172.1 450.9 160.8 405.6 143 451.3 129 404.8 110.6 449.9 96.1 403.9 77.6 452 65.1 405.4 45.4 451.1 40.7 412.2 15.5 437.4',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Vertical}`]: [
				'177.9 128.3 182.7 144.6 169.3 149.4 178.4 162.3 164.1 166.3 175 177.8 162.5 184.3 173.1 193.1 157.9 197.3 170.4 209 155.1 214.6 167.9 224.1 153.8 229.3 166.3 238.2 151.4 242.3 163.8 252 150.2 257.5 160.9 265.7 149.6 270.4 160.5 278.9 148.6 283.8 159.4 292.3 146.7 297.4 157 305.5 145.3 310.3 155.6 318.2 141 324.2 151.5 332.4 138.9 337.6 149.6 346.1 135.5 351.9 146.9 360.9 131.6 367.1 142.8 376',
				'74 376.8 86.6 365.1 72.7 358.9 84.3 349.6 70.2 343.8 82.6 335 70.6 328.5 81.8 321.4 68 313.9 79.1 307.1 68 301.1 79.1 294.3 67 287.7 78.7 280.4 67.4 274.3 79 267.1 68.4 261.2 79.8 254.1 67 247.2 80.3 238.9 68 232 81.2 223.9 68.3 216.9 81.3 208.9 66.8 200.9 78.7 193.4 67.9 185.4 80.5 179.1 71.1 170.5 84.2 163.8 74.2 153.3 89.4 149.8 83.9 136.2 96.6 135.9 93.5 113.1',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Horizontal}`]: [
				'178.6 258 170 242.5 153.5 259.1 143.6 242.3 128.6 258 114.8 240.8 103.4 258.2 89.6 240.3 72.6 257.8 59 241.1 44.3 256.8',
			],
		},
	},
};
